module.exports = __webpack_public_path__ + "static/media/sj.b884cec9.svg";